import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MapService } from '../../api/services/map.service';

/**
 * Attaches the current map ID to each outgoing HTTP request via X-Map-Id header.
 */
@Injectable()
export class MapContextInterceptor implements HttpInterceptor {
  constructor(private mapService: MapService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Use MapService to get the currently selected map from store/localStorage
    const map = this.mapService.getCurrentSelectedMapFromStore();
    const mapId = map?.id;
    if (mapId) {
      request = request.clone({
        setHeaders: {
          'X-Map-Id': mapId
        }
      });
    }
    return next.handle(request);
  }
}